<template>
  <div class="swiper loading" v-show="isShow.isLDShow">
    <div class="calendarContainer">
      <div class="timestep"></div>
    </div>
    <div class="preImgBox">
      <span v-for="(data,index) in preLoadImg" :key="generateId(index)">
        <img v-bind:id="generateId(index)" src="" style="visibility: hidden; width: 1px; height: 1px; position: absolute;">
      </span>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    isShow: {
      type: Object
    }
  },
  data () {
    return {
      loadingNum: 0,
      preLoadImg: [
        { src: require('../rotate/phone_horizon.png') },
        { src: require('../musicplayer/music_note.png') },
        { src: require('../pageKV/a1-bg.jpg') },
        { src: require('../pageKV/a1-bg2.jpg') },
        { src: require('../pageKV/a1-bg3.jpg') },
        { src: require('../pageKV/a1-s1.jpg') },
        { src: require('../pageKV/a1-s2.jpg') },
        { src: require('../pageKV/a1-s3.jpg') },
        { src: require('../pageKV/a1-s4.jpg') },
        { src: require('../pageKV/a1-s5.jpg') },
        { src: require('../pageKV/a1-s6.jpg') },
        { src: require('../pageKV/a1-s7.jpg') },
        { src: require('../pageKV/a1-s8.jpg') },
        { src: require('../pageKV/a1-s9.jpg') },
        { src: require('../pageKV/a1-s10.jpg') },
        { src: require('../pageKV/a1-s11.jpg') },
        { src: require('../pageKV/a1-s12.jpg') },
        { src: require('../pageKV/a1-s13.jpg') },
        { src: require('../pageKV/a1-s14.jpg') },
        { src: require('../pageKV/a1-s15.jpg') },
        { src: require('../pageKV/a1-s16.jpg') },
        { src: require('../pageKV/a1-s17.jpg') },
        { src: require('../pageKV/a1-s18.jpg') },
        { src: require('../pageKV/a1-s19.jpg') },
        { src: require('../pageKV/a1-s20.jpg') },
        { src: require('../pageKV/a1-s21.jpg') },
        { src: require('../pageKV/a1-s22.jpg') },
        { src: require('../pageKV/a1-s23.jpg') },
        { src: require('../pageKV/a1-s24.jpg') },
        { src: require('../pageKV/a1-s25.jpg') },
        { src: require('../pageKV/a1-s26.jpg') },
        { src: require('../pageKV/a1-s27.jpg') },
        { src: require('../pageKV/a1-s28.jpg') },
        { src: require('../pageKV/a1-s29.jpg') },
        { src: require('../pageKV/a1-s30.jpg') },
        { src: require('../pageKV/a1-s31.jpg') },
        { src: require('../pageKV/a1-s32.jpg') },
        { src: require('../pageKV/a1-s33.jpg') },
        { src: require('../pageKV/a1-s34.jpg') },
        { src: require('../pageKV/a1-s35.jpg') },
        { src: require('../pageKV/a1-s36.jpg') },
        { src: require('../pageKV/a1-s37.jpg') },
        { src: require('../pageKV/a1-s38.jpg') },
        { src: require('../pageKV/a1-s39.jpg') },
        { src: require('../pageKV/a1-s40.jpg') },
        { src: require('../pageKV/a1-txt1.png') },
        { src: require('../pageKV/a1-txt2.png') },
        { src: require('../pageKV/a1-txt3.png') },
        { src: require('../pageKV/a2-s1.jpg') },
        { src: require('../pageKV/a2-s2.jpg') },
        { src: require('../pageKV/a2-s3.jpg') },
        { src: require('../pageKV/a2-s4.jpg') },
        { src: require('../pageKV/a2-s5.jpg') },
        { src: require('../pageKV/a2-s6.jpg') },
        { src: require('../pageKV/a2-s7.jpg') },
        { src: require('../pageKV/a2-s8.jpg') },
        { src: require('../pageKV/a2-s9.jpg') },
        { src: require('../pageKV/a2-s10.jpg') },
        { src: require('../pageKV/a2-s11.jpg') },
        { src: require('../pageKV/a2-s12.jpg') },
        { src: require('../pageKV/a2-s13.jpg') },
        { src: require('../pageKV/a2-s14.jpg') },
        { src: require('../pageKV/a2-s15.jpg') },
        { src: require('../pageKV/a2-s16.jpg') },
        { src: require('../pageKV/a2-s17.jpg') },
        { src: require('../pageKV/a2-s18.jpg') },
        { src: require('../pageKV/a2-s19.jpg') },
        { src: require('../pageKV/a2-s20.jpg') },
        { src: require('../pageKV/a2-s21.jpg') },
        { src: require('../pageKV/a2-s22.jpg') },
        { src: require('../pageKV/a2-s23.jpg') },
        { src: require('../pageKV/a2-s24.jpg') },
        { src: require('../pageKV/a2-s25.jpg') },
        { src: require('../pageKV/a2-s26.jpg') },
        { src: require('../pageKV/a2-s27.jpg') },
        { src: require('../pageKV/a2-s28.jpg') },
        { src: require('../pageKV/a2-s29.jpg') },
        { src: require('../pageKV/a2-s30.jpg') },
        { src: require('../pageKV/a2-s31.jpg') },
        { src: require('../pageKV/a2-s32.jpg') },
        { src: require('../pageKV/a2-s33.jpg') },
        { src: require('../pageKV/a2-s34.jpg') },
        { src: require('../pageKV/a2-s35.jpg') },
        { src: require('../pageKV/a2-s36.jpg') },
        { src: require('../pageKV/a2-s37.jpg') },
        { src: require('../pageKV/a2-s38.jpg') },
        { src: require('../pageKV/a2-s39.jpg') },
        { src: require('../pageKV/a2-s40.jpg') },
        { src: require('../pageKV/a2-s41.jpg') },
        { src: require('../pageKV/a2-s42.jpg') },
        { src: require('../pageKV/a2-s43.jpg') },
        { src: require('../pageKV/a2-s44.jpg') },
        { src: require('../pageKV/a2-s45.jpg') },
        { src: require('../pageKV/a2-s46.jpg') },
        { src: require('../pageKV/a2-s47.jpg') },
        { src: require('../pageKV/a2-s48.jpg') },
        { src: require('../pageKV/a2-s49.jpg') },
        { src: require('../pageKV/a2-s50.jpg') },
        { src: require('../pageKV/a2-s51.jpg') },
        { src: require('../pageKV/a2-s52.jpg') },
        { src: require('../pageKV/a2-s53.jpg') },
        { src: require('../pageKV/a2-s54.jpg') },
        { src: require('../pageKV/a2-s55.jpg') },
        { src: require('../pageKV/a2-s56.jpg') },
        { src: require('../pageKV/a2-s57.jpg') },
        { src: require('../pageKV/a2-s58.jpg') },
        { src: require('../pageKV/a2-s59.jpg') },
        { src: require('../pageKV/a2-s60.jpg') },
        { src: require('../pageKV/a2-s61.jpg') },
        { src: require('../pageKV/a2-s62.jpg') },
        { src: require('../pageKV/a2-s63.jpg') },
        { src: require('../pageKV/a2-s64.jpg') },
        { src: require('../pageKV/a2-s65.jpg') },
        { src: require('../pageKV/a2-s66.jpg') },
        { src: require('../pageKV/a2-s67.jpg') },
        { src: require('../pageKV/a2-s68.jpg') },
        { src: require('../pageKV/a2-s69.jpg') },
        { src: require('../pageKV/a2-s70.jpg') },
        { src: require('../pageKV/a2-s71.jpg') },
        { src: require('../pageKV/a2-s72.jpg') },
        { src: require('../pageKV/a2-txt1.png') },
        { src: require('../pageKV/a2-txt2.png') },
        { src: require('../pageKV/a3-s1.jpg') },
        { src: require('../pageKV/a3-s2.jpg') },
        { src: require('../pageKV/a3-s3.jpg') },
        { src: require('../pageKV/a3-s4.jpg') },
        { src: require('../pageKV/a3-s5.jpg') },
        { src: require('../pageKV/a3-s6.jpg') },
        { src: require('../pageKV/a3-s7.jpg') },
        { src: require('../pageKV/a3-s8.jpg') },
        { src: require('../pageKV/a3-s9.jpg') },
        { src: require('../pageKV/a3-s10.jpg') },
        { src: require('../pageKV/a3-s11.jpg') },
        { src: require('../pageKV/a3-s12.jpg') },
        { src: require('../pageKV/a3-s13.jpg') },
        { src: require('../pageKV/a3-s14.jpg') },
        { src: require('../pageKV/a3-s15.jpg') },
        { src: require('../pageKV/a3-s16.jpg') },
        { src: require('../pageKV/a3-s17.jpg') },
        { src: require('../pageKV/a3-s18.jpg') },
        { src: require('../pageKV/a3-s19.jpg') },
        { src: require('../pageKV/a3-s20.jpg') },
        { src: require('../pageKV/a3-s21.jpg') },
        { src: require('../pageKV/a3-s22.jpg') },
        { src: require('../pageKV/a3-s23.jpg') },
        { src: require('../pageKV/a3-s24.jpg') },
        { src: require('../pageKV/a3-s25.jpg') },
        { src: require('../pageKV/a3-s26.jpg') },
        { src: require('../pageKV/a3-s27.jpg') },
        { src: require('../pageKV/a3-s28.jpg') },
        { src: require('../pageKV/a3-s29.jpg') },
        { src: require('../pageKV/a3-s30.jpg') },
        { src: require('../pageKV/a3-s31.jpg') },
        { src: require('../pageKV/a3-s32.jpg') },
        { src: require('../pageKV/a3-s33.jpg') },
        { src: require('../pageKV/a3-s34.jpg') },
        { src: require('../pageKV/a3-s35.jpg') },
        { src: require('../pageKV/a3-s36.jpg') },
        { src: require('../pageKV/a3-s37.jpg') },
        { src: require('../pageKV/a3-s38.jpg') },
        { src: require('../pageKV/a3-s39.jpg') },
        { src: require('../pageKV/a3-s40.jpg') },
        { src: require('../pageKV/a3-s41.jpg') },
        { src: require('../pageKV/a3-s42.jpg') },
        { src: require('../pageKV/a3-s43.jpg') },
        { src: require('../pageKV/a3-s44.jpg') },
        { src: require('../pageKV/a3-s45.jpg') },
        { src: require('../pageKV/a3-s46.jpg') },
        { src: require('../pageKV/a3-s47.jpg') },
        { src: require('../pageKV/a3-s48.jpg') },
        { src: require('../pageKV/a3-s49.jpg') },
        { src: require('../pageKV/a3-s50.jpg') },
        { src: require('../pageKV/a3-s51.jpg') },
        { src: require('../pageKV/a3-s52.jpg') },
        { src: require('../pageKV/a3-s53.jpg') },
        { src: require('../pageKV/a3-s54.jpg') },
        { src: require('../pageKV/a3-s55.jpg') },
        { src: require('../pageKV/a3-s56.jpg') },
        { src: require('../pageKV/a3-s57.jpg') },
        { src: require('../pageKV/a3-s58.jpg') },
        { src: require('../pageKV/a3-s59.jpg') },
        { src: require('../pageKV/a3-s60.jpg') },
        { src: require('../pageKV/a3-s61.jpg') },
        { src: require('../pageKV/a3-s62.jpg') },
        { src: require('../pageKV/a3-s63.jpg') },
        { src: require('../pageKV/a3-s64.jpg') },
        { src: require('../pageKV/a3-s65.jpg') },
        { src: require('../pageKV/a3-s66.jpg') },
        { src: require('../pageKV/a3-s67.jpg') },
        { src: require('../pageKV/a3-s68.jpg') },
        { src: require('../pageKV/a3-s69.jpg') },
        { src: require('../pageKV/a3-s70.jpg') },
        { src: require('../pageKV/a3-s71.jpg') },
        { src: require('../pageKV/a3-s72.jpg') },
        { src: require('../pageKV/a3-s73.jpg') },
        { src: require('../pageKV/a3-s74.jpg') },
        { src: require('../pageKV/a3-s75.jpg') },
        { src: require('../pageKV/a3-s76.jpg') },
        { src: require('../pageKV/a3-s77.jpg') },
        { src: require('../pageKV/a3-s78.jpg') },
        { src: require('../pageKV/a3-s79.jpg') },
        { src: require('../pageKV/a3-s80.jpg') },
        { src: require('../pageKV/a3-s81.jpg') },
        { src: require('../pageKV/a3-s82.jpg') },
        { src: require('../pageKV/a3-s83.jpg') },
        { src: require('../pageKV/a3-s84.jpg') },
        { src: require('../pageKV/a3-s85.jpg') },
        { src: require('../pageKV/a3-txt1.png') },
        { src: require('../pageKV/a3-txt2.png') },
        { src: require('../pageKV/a4-txt1.png') },
        { src: require('../pageKV/a4-txt2.png') },
        { src: require('../pageKV/a5-bg2.jpg') },
        { src: require('../pageKV/a5-bg3.jpg') },
        { src: require('../pageKV/a5-s1.jpg') },
        { src: require('../pageKV/a5-s2.jpg') },
        { src: require('../pageKV/a5-s3.jpg') },
        { src: require('../pageKV/a5-s4.jpg') },
        { src: require('../pageKV/a5-s5.jpg') },
        { src: require('../pageKV/a5-s6.jpg') },
        { src: require('../pageKV/a5-s7.jpg') },
        { src: require('../pageKV/a5-s8.jpg') },
        { src: require('../pageKV/a5-s9.jpg') },
        { src: require('../pageKV/a5-s10.jpg') },
        { src: require('../pageKV/a5-s11.jpg') },
        { src: require('../pageKV/a5-s12.jpg') },
        { src: require('../pageKV/a5-s13.jpg') },
        { src: require('../pageKV/a5-s14.jpg') },
        { src: require('../pageKV/a5-s15.jpg') },
        { src: require('../pageKV/a5-s16.jpg') },
        { src: require('../pageKV/a5-s17.jpg') },
        { src: require('../pageKV/a5-s18.jpg') },
        { src: require('../pageKV/a5-s19.jpg') },
        { src: require('../pageKV/a5-s20.jpg') },
        { src: require('../pageKV/a5-s21.jpg') },
        { src: require('../pageKV/a5-s22.jpg') },
        { src: require('../pageKV/a5-s23.jpg') },
        { src: require('../pageKV/a5-s24.jpg') },
        { src: require('../pageKV/a5-s25.jpg') },
        { src: require('../pageKV/a5-s26.jpg') },
        { src: require('../pageKV/a5-s27.jpg') },
        { src: require('../pageKV/a5-s28.jpg') },
        { src: require('../pageKV/a5-s29.jpg') },
        { src: require('../pageKV/a5-s30.jpg') },
        { src: require('../pageKV/a5-txt1.png') },
        { src: require('../pageKV/a5-txt2.png') },
        { src: require('../pageKV/a5-txt3.png') },
        { src: require('../pageKV/a6-1.png') },
        { src: require('../pageKV/a6-2.png') },
        { src: require('../pageKV/a6-3.png') },
        { src: require('../pageKV/a6-4.png') },
        { src: require('../pageKV/a6-5.png') },
        { src: require('../pageKV/a6-6.png') },
        { src: require('../pageKV/a6-7.png') },
        { src: require('../pageKV/a6-8.png') },
        { src: require('../pageKV/a6-bg.jpg') },
        { src: require('../pageKV/a6-txt1.png') },
        { src: require('../pageKV/a6-txt2.png') },
        { src: require('../pageKV/a6-txt3.png') },
        { src: require('../pageKV/result-1.png') },
        { src: require('../pageKV/result-2.png') },
        { src: require('../pageKV/result-3.png') },
        { src: require('../pageKV/result-bg.jpg') },
        { src: require('../pageKV/result-bg.png') },
        { src: require('../pageKV/result-btn1.png') },
        { src: require('../pageKV/result-btn2.png') },
        { src: require('../pageKV/result-logo.jpg') },
        { src: require('../pageKV/result-y1.png') },
        { src: require('../pageKV/result-y2.png') },
        { src: require('../pageKV/result-y3.png') },
        { src: require('../pageKV/result-y4.png') },
        { src: require('../pageKV/result-y5.png') },
        { src: require('../pageKV/result-y6.png') },
        { src: require('../pageKV/result-y7.png') },
        { src: require('../pageKV/result-y8.png') },
        { src: require('../pageKV/s1-1.png') },
        { src: require('../pageKV/s1-2.png') },
        { src: require('../pageKV/s1-3.png') },
        { src: require('../pageKV/s1-4.png') },
        { src: require('../pageKV/s1-5.png') },
        { src: require('../pageKV/s1-6.png') },
        { src: require('../pageKV/s1-7.png') },
        { src: require('../pageKV/s1-8.png') },
        { src: require('../pageKV/s1-9.png') },
        { src: require('../pageKV/s1-10.png') },
        { src: require('../pageKV/s1-11.png') },
        { src: require('../pageKV/s1bg.jpg') },
        { src: require('../pageKV/share-tip1.png') },
        { src: require('../pageKV/share-tip2.png') },
        { src: require('../pageKV/result-moon.png') },
        { src: require('../pageKV/result-moon2.png') },
        { src: require('../pageKV/result-stars.png') },
        { src: require('../pageKV/result-txt1.png') },
        { src: require('../pageKV/result-txt2.png') },
        { src: require('../pageKV/hand.png') },
      ]
    }
  },
  methods: {
    generateId (index) {
      return 'mImg' + index
    },
    go () {
      this.isShow.isLDShow = false
      this.isShow.isKVShow = true

      this.$emit('gogame')
    },
    loadNextImg(imgID, max){
      let allImg = $('.preImgBox img')
      let _this = this
      let imgSrc = this.preLoadImg[imgID]['src']

      allImg.eq(imgID).attr('src', imgSrc)
      allImg.eq(imgID)
        .load(function () {
          _this.loadingNum = parseInt(imgID / max*100)
            imgID++
            if(imgID >= max){
              console.log('complete')
              _this.loadingNum = 100
              _this.go()
            }else{
              _this.loadNextImg(imgID,max)
            }
        })
    }
  },
  mounted () {
    let that = this
    let allImg = $('.preImgBox img')
    let allImgNum = allImg.length
    let imgID = 0
    setTimeout(() => {
      that.loadNextImg(imgID, allImgNum)
    }, 200)
  }
}
</script>

<style lang="less" scoped>
.loading {
  position: relative;
  width: 100%;
  height: 100%;
  background:#aac6fb url(bg.jpg);
  background-size:100% 100%;

  .calendarContainer{
    width: 40.625/4rem /* 650/16 */;
    height: 20.0625/4rem /* 321/16 */;

    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -40.625/8rem /* 650/16 */;
    margin-top: -20.0625/8rem /* 321/16 */;
    background-image: url(l0.png);
    background-size: 100% 100%;
  }

  .timestep{
    background-size: 100% 100%;
    animation: 5s timer infinite;
    width:100%;
    height: 100%;
  }

}

@keyframes timer {
  0%{ 
    background-image: url(t0.png);
  }
  10%{ 
    background-image: url(t0.png);
  }
  11%{ 
    background-image: url(t1.png);
  }
  21%{ 
    background-image: url(t1.png);
  }
  22%{ 
    background-image: url(t2.png);
  }
  32%{ 
    background-image: url(t2.png);
  }
  33%{ 
    background-image: url(t3.png);
  }
  43%{ 
    background-image: url(t3.png);
  }
  44%{ 
    background-image: url(t4.png);
  }
  54%{ 
    background-image: url(t4.png);
  }
  55%{ 
    background-image: url(t5.png);
  }
  65%{ 
    background-image: url(t5.png);
  }
  66%{ 
    background-image: url(t6.png);
  }
  76%{ 
    background-image: url(t6.png);
  }
  77%{ 
    background-image: url(t7.png);
  }
  99%{ 
    background-image: url(t7.png);
  }
  100%{ 
    background-image: url(t1.png);
  }
}
</style>
